import axios from 'axios';
import { constructServiceURL } from '../../../../utils/URLTools';

const getOperatorsWithImpcsByRole = () => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getOperatorsWithImpcsByRole',
    stub: process.env.useStubbedEndpoints,
  });

  return axios.get(serviceUrl);
};

const getAllOperatorsWithImpcs = () => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getAllOperatorsWithImpcs',
    stub: process.env.useStubbedEndpoints,
  });

  return axios.get(serviceUrl);
};

const getUserData = () => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getUserData',
    stub: process.env.useStubbedEndpoints,
  });

  return axios.post(serviceUrl);
};

const getGlobalImpcAssetPreset = (appContext) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getGlobalImpcAssetPreset',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext,
    },
  });

  return axios.get(serviceUrl);
};

const getGlobalOperatorAssetPreset = (appContext) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getGlobalOperatorAssetPreset',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext,
    },
  });

  return axios.get(serviceUrl);
};

const getAssetTypeOperatorsWithImpcs = (appContext) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getAssetTypeOperatorsWithImpcs',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext,
    },
  });

  return axios.get(serviceUrl);
};

export default {
  getUserData,
  getOperatorsWithImpcsByRole,
  getAllOperatorsWithImpcs,
  getGlobalImpcAssetPreset,
  getGlobalOperatorAssetPreset,
  getAssetTypeOperatorsWithImpcs,
};
